/*eslint-disable */
import { Cloudinary } from 'cloudinary-core'

const cloudinaryCore = new Cloudinary({cloud_name: 'rbns'})

export default cloudinaryCore
